import React, { useState } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Chip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import LaunchIcon from '@mui/icons-material/Launch';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CampaignIcon from '@mui/icons-material/Campaign';
import ElderlyIcon from '@mui/icons-material/Elderly';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CodeIcon from '@mui/icons-material/Code';
import GavelIcon from '@mui/icons-material/Gavel';
import ExtensionIcon from '@mui/icons-material/Extension';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

const modules = [
  // { id: 1, label: 'AHCA', description: 'Information about AHCA.', icon: <FavoriteIcon />, iconColor: '#ff6b6b', path: '/AHCA' , badge: 'soon' },
  { id: 2, label: 'Care Gap', description: 'Care gap management.', icon: <AssessmentIcon />, iconColor: '#4dabf5', path: '/CareGap' , badge: '' },
  { id: 3, label: 'Welcome Campaign', description: 'Welcome campaign.', icon: <CampaignIcon />, iconColor: '#f9a825', path: '/WelcomeCampaign' , badge: '' },
  // { id: 4, label: 'ACA Aging 62-65', description: 'ACA 62-65 follow-up.', icon: <ElderlyIcon />, iconColor: '#9ccc65', path: '/ACAAging6265' , badge: 'offline' },
  // { id: 5, label: 'ACA Aging 65', description: 'ACA information for age 65.', icon: <ElderlyIcon />, iconColor: '#81c784', path: '/ACAAging65' , badge: 'offline' },
  { id: 6, label: 'Post Visit', description: 'Post-visit management.', icon: <PostAddIcon />, iconColor: '#ba68c8', path: '/PostVisit' , badge: '' },
  { id: 8, label: 'Coding Opportunities', description: 'Clinical coding opportunities.', icon: <CodeIcon />, iconColor: '#ffa726', path: '/coding-opportunities' , badge: '' },
  { id: 9, label: 'Pre & Post Audit', description: 'Pre and post audit.', icon: <GavelIcon />, iconColor: '#a1887f', path: '/PrePostAudi' , badge: '' },
  { id: 10, label: 'Add on', description: 'Additional modules.', icon: <ExtensionIcon />, iconColor: '#4db6ac', path: '/AddOn' , badge: '' },
  // { id: 11, label: 'New Member', description: 'New member management.', icon: <PersonAddIcon />, iconColor: '#64b5f6', path: '/NewMember' , badge: 'offline' },
  { id: 12, label: 'No Recent Visit', description: 'Patients without recent visits.', icon: <VisibilityOffIcon />, iconColor: '#e57373', path: '/no-recent-visits' , badge: '' },
  { id: 14, label: 'PCP Changes', description: 'PCP changes.', icon: <SwapHorizIcon />, iconColor: '#f06292', path: '/PCPChanges' , badge: '' },
  { id: 15, label: 'Specialists Referrals', description: 'Specialist referrals.', icon: <LocalHospitalIcon />, iconColor: '#7986cb', path: '/specialist-referrals' , badge: '' },
  { id: 16, label: 'Lab Phlebotomy', description: 'Laboratory phlebotomy.', icon: <LocalHospitalIcon />, iconColor: '#4db6ac', path: '/LabPhlebotomy' , badge: '' },

];

export default function ModulesMenu() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const filteredModules = modules.filter((mod) =>
    mod.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <TextField
          placeholder="🔍 Buscar módulo..."
          variant="outlined"
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: <SearchIcon color="action" />,
          }}
        />
      </Box>

      <Grid container spacing={3}>
        {filteredModules.map((mod) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={mod.id}>
            <Card
              onClick={() => {
                if (mod.badge !== 'offline') navigate(mod.path);
              }}
              sx={{
                height: 190,
                cursor: mod.badge === 'offline' ? 'not-allowed' : 'pointer',
                position: 'relative',
                opacity: mod.badge === 'offline' ? 0.5 : 1,
                pointerEvents: mod.badge === 'offline' ? 'none' : 'auto',
                borderRadius: 3,
                transition: 'all 0.4s ease',
                background: '#ffffff',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                '&:hover': {
                  transform: mod.badge !== 'offline' ? 'scale(1.035)' : 'none',
                  boxShadow: mod.badge !== 'offline' ? `0 0 20px ${mod.iconColor}55, inset 0 0 6px ${mod.iconColor}33` : '',
                },
              }}
            >
              {mod.badge && (
                <Box sx={{ position: 'absolute', top: 10, right: 10 }}>
                  <Chip
                    label={
                      mod.badge === 'new'
                        ? '🆕 New'
                        : mod.badge === 'offline'
                        ? '🚫 OffLine'
                        : mod.badge === 'beta'
                        ? '🧪 Beta'
                        : mod.badge === 'soon'
                        ? '⏳ Soon'
                        : ''
                    }
                    color={
                      mod.badge === 'new'
                        ? 'success'
                        : mod.badge === 'offline'
                        ? 'error'
                        : mod.badge === 'beta'
                        ? 'warning'
                        : mod.badge === 'soon'
                        ? 'info'
                        : 'default'
                    }
                    size="small"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '0.75rem',
                      textTransform: 'none'
                    }}
                  />
                </Box>
              )}
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <Typography variant="h6" fontWeight="bold">
                    {mod.label}
                  </Typography>
                  <Tooltip title="Ir al módulo">
                    <IconButton size="small">
                      <LaunchIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  {mod.description}
                </Typography>

                <Box
                  mt={3}
                  display="flex"
                  justifyContent="center"
                >
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: mod.iconColor,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: '#fff',
                      fontSize: 28,
                      boxShadow: `0 4px 10px ${mod.iconColor}66`, // sutil sombra del mismo color
                      transition: 'transform 0.3s',
                      '&:hover': {
                        transform: 'scale(1.1)',
                      }
                    }}
                  >
                    {mod.icon}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}

        {filteredModules.length === 0 && (
          <Grid item xs={12}>
            <Typography variant="h6" textAlign="center">
              ❌ No se encontraron módulos con ese nombre.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}